import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import enLocale from 'element-ui/lib/locale/lang/en'
import koLocale from 'element-ui/lib/locale/lang/ko'
import zhCN from './zh-CN'
import zhCN_DLC from './zh-CN-DLC'
import zhTW from './zh-TW'
import zhTW_DLC from './zh-CHT-DLC'
import enUS from './en-US'
import enUS_DLC from './en-US-DLC'
import koKR_DLC from './ko-KR-DLC'
import { cookieGet } from '@/common/cookie'

Vue.use(VueI18n)

export const messages = {
  'zh-CN': {
    '_lang': '简体中文',
    ...zhCN,
    ...zhCNLocale,
    ...zhCN_DLC,
  },
  'zh-TW': {
    '_lang': '繁體中文',
    ...zhTW,
    ...zhTWLocale,
    ...zhTW_DLC,
  },
  'en-US': {
    '_lang': 'English',
    ...enUS,
    ...enLocale,
    ...enUS_DLC,
  },
  'ko-KR': {
    '_lang': '한국어',
    ...koLocale,
    ...koKR_DLC,
  }
}

if (process.env.NODE_ENV === 'development') {
  //这里给一个测试环境,方便找出未翻译的文本
  messages['test'] = {
    ...zhCN,
    ...zhCNLocale,
    // 兼容18nhelper
    dlc: new Proxy({}, {
      get(t, k, r) {
        return r;
      },
      set() {
        return false;
      }
    })
  }
}

export default new VueI18n({
  locale: cookieGet('language') || 'en-US',
  messages
})
